module.exports = __webpack_public_path__ + "assets/manual_childAccident-b20808f6cf42b642cfc12fbbabf1e791.pdf";